import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 10px 20px 40px;
  display: flex;
  flex-direction: column;
  zindex: 999;
  background-color: #eee;
  border-radius: 8px;
  font-size: 1.6rem;
`;

export const Icon = styled.div`
  ${({ theme }) => css`
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    font-size: 2rem;
    color: ${theme.colors.report};
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    font-size: 2rem;
    text-align: center;
    color: ${theme.colors.darkGrey};
  `}
`;

export const Subtitle = styled.div`
  margin-top: 1rem;
  text-align: center;
  font-size: 1.5rem;
`;

export const Error = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    text-align: center;
    color: ${theme.colors.error};
    font-size: ${theme.fontSizes.meddium};
  `}
`;
